/**
 * HTML-escape a plain-text string for safe interpolation into markup.
 *
 * One shared implementation (review consolidation): the compliance
 * disclaimer footer (newsletter-ai/compliance-prechecks) and the email
 * shell's preheader/title (utils/emailShell) escape user-influenced text
 * with the SAME security-relevant function — hardening one path must
 * harden the other.
 */
export const escapeHtmlText = (value) =>
  String(value ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');

export default escapeHtmlText;
